import { withInstall } from '@element-plus/utils'

import Pagination from './src/pagination'

export const ElPagination = withInstall(Pagination)
export default ElPagination

export * from './src/pagination'
